(function () {
  if (window.Intellino) return;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var designMode = !!(window.Shopify && window.Shopify.designMode);
  var revealObserver = null;

  function luminance(c) {
    return (0.2126 * c[0] + 0.7152 * c[1] + 0.0722 * c[2]) / 255;
  }

  function gradientLuminance(image) {
    var stops = (image.match(/rgba?\([^)]+\)/g) || [])
      .map(function (stop) { return stop.match(/[\d.]+/g); })
      .filter(function (c) { return c.length < 4 || parseFloat(c[3]) > 0.3; });
    if (!stops.length) return null;
    return stops.reduce(function (sum, c) { return sum + luminance(c); }, 0) / stops.length;
  }

  function hasLightBackground(el) {
    while (el && el !== document.body) {
      var style = window.getComputedStyle(el);
      if (style.backgroundImage.indexOf('gradient') !== -1) {
        var g = gradientLuminance(style.backgroundImage);
        if (g !== null) return g > 0.6;
      }
      var rgba = style.backgroundColor.match(/[\d.]+/g);
      if (rgba && (rgba.length < 4 || parseFloat(rgba[3]) > 0.5)) return luminance(rgba) > 0.6;
      el = el.parentElement;
    }
    var body = window.getComputedStyle(document.body).backgroundColor.match(/[\d.]+/g);
    return !body || luminance(body) > 0.6;
  }

  function initNavTone(nav) {
    var queued = false;

    function update() {
      queued = false;
      var probeY = nav.getBoundingClientRect().bottom + 1;
      var probe = probeY > 0 && probeY < window.innerHeight ? document.elementFromPoint(4, probeY) : null;
      nav.classList.toggle('is-light', !!probe && hasLightBackground(probe));
    }

    function queue() {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(update);
    }

    update();
    window.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', queue);
    window.addEventListener('load', queue);
  }

  function initGlobalNav(scope) {
    scope.querySelectorAll('[data-ig-globalnav]').forEach(function (nav) {
      if (nav.dataset.igReady === 'true') return;
      nav.dataset.igReady = 'true';

      initNavTone(nav);

      var toggle = nav.querySelector('[data-ig-toggle]');
      if (!toggle) return;

      function setOpen(open) {
        nav.setAttribute('data-open', open ? 'true' : 'false');
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        toggle.setAttribute('aria-label', open ? toggle.dataset.labelClose : toggle.dataset.labelOpen);
        document.documentElement.style.overflow = open ? 'hidden' : '';
      }

      toggle.addEventListener('click', function () {
        setOpen(nav.getAttribute('data-open') !== 'true');
      });

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && nav.getAttribute('data-open') === 'true') {
          setOpen(false);
          toggle.focus();
        }
      });

      window.addEventListener('resize', function () {
        if (window.innerWidth > 989 && nav.getAttribute('data-open') === 'true') setOpen(false);
      });
    });
  }

  function findTarget(hash) {
    var id = decodeURIComponent(hash.replace(/^#/, ''));
    if (!id) return null;
    return (
      document.getElementById(id) ||
      document.querySelector('[id$="__' + id.replace(/"/g, '') + '"]')
    );
  }

  function initLocalNav(scope) {
    scope.querySelectorAll('[data-ig-localnav]').forEach(function (nav) {
      if (nav.dataset.igReady === 'true') return;
      nav.dataset.igReady = 'true';

      nav.querySelectorAll('a[href^="#"]').forEach(function (link) {
        link.addEventListener('click', function (event) {
          var target = findTarget(link.getAttribute('href'));
          if (!target) return;
          event.preventDefault();
          var offset = nav.offsetHeight + 28;
          var top = target.getBoundingClientRect().top + window.scrollY - offset;
          window.scrollTo({ top: top, behavior: reduceMotion.matches ? 'auto' : 'smooth' });
        });
      });

      var restingTop = null;
      function onScroll() {
        if (restingTop === null) restingTop = nav.getBoundingClientRect().top + window.scrollY;
        nav.classList.toggle('is-stuck', window.scrollY > restingTop - 20);
      }
      onScroll();
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', function () {
        restingTop = null;
        onScroll();
      });
    });
  }

  function initReveal(scope) {
    var items = Array.prototype.slice.call(scope.querySelectorAll('[data-ig-reveal]:not(.is-revealed)'));
    if (!items.length) return;

    if (designMode || reduceMotion.matches || !('IntersectionObserver' in window)) {
      items.forEach(function (item) {
        item.classList.add('is-revealed');
      });
      return;
    }

    document.documentElement.classList.add('ig-motion');

    if (!revealObserver) {
      revealObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-revealed');
            revealObserver.unobserve(entry.target);
          });
        },
        { rootMargin: '0px 0px -8% 0px', threshold: 0.12 }
      );
    }

    items.forEach(function (item) {
      revealObserver.observe(item);
    });
  }

  function init(scope) {
    scope = scope || document;
    initGlobalNav(scope);
    initLocalNav(scope);
    initReveal(scope);
  }

  window.Intellino = { init: init };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target && event.target.querySelector) init(event.target);
  });
})();
